<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3732"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3736"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3746"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3744" /></clipPath></defs><g
     id="g3738"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3740"><g
         id="g3742"
         clip-path="url(#clipPath3746)"><g
           id="g3748"
           transform="translate(504.5,256)"><path
             d="m 0,0 c 0,-137.243 -111.257,-248.5 -248.5,-248.5 -137.243,0 -248.5,111.257 -248.5,248.5 0,137.243 111.257,248.5 248.5,248.5 C -111.257,248.5 0,137.243 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3750" /></g><g
           id="g3752"
           transform="translate(322.4678,210.7451)"><path
             d="M 0,0 108.895,108.895 -2.828,220.617 -111.723,111.723"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3754" /></g><g
           id="g3756"
           transform="translate(189.5322,301.2549)"><path
             d="M 0,0 -108.896,-108.896 2.827,-220.619 111.723,-111.723"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3758" /></g><g
           id="g3760"
           transform="translate(299.5947,233.6191)"><path
             d="m 0,0 c 9.465,18.427 6.488,41.594 -8.946,57.029 -15.436,15.436 -38.603,18.411 -57.03,8.947"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3762" /></g><g
           id="g3764"
           transform="translate(212.4058,278.3809)"><path
             d="M 0,0 C -9.465,-18.427 -6.489,-41.594 8.946,-57.029 24.381,-72.464 47.548,-75.44 65.975,-65.976"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3766" /></g><g
           id="g3768"
           transform="translate(200.1387,200.1387)"><path
             d="m 0,0 c 5.858,-5.858 5.858,-15.355 0,-21.213 -5.858,-5.858 -15.355,-5.858 -21.213,0 -5.858,5.858 -5.858,15.355 0,21.213 C -15.355,5.857 -5.858,5.857 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3770" /></g><g
           id="g3772"
           transform="translate(333.0742,333.0742)"><path
             d="m 0,0 c 5.858,-5.857 5.858,-15.354 0,-21.213 -5.857,-5.857 -15.354,-5.857 -21.213,0 -5.857,5.859 -5.857,15.356 0,21.213 C -15.354,5.858 -5.857,5.858 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3774" /></g><g
           id="g3776"
           transform="translate(301.2549,231.959)"><path
             d="m 0,0 72.439,72.439 c -5.535,9.374 -5.535,21.11 0,30.483 l -38.813,38.813 c -9.373,-5.535 -21.109,-5.535 -30.482,0 l -72.44,-72.439"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3778" /></g><g
           id="g3780"
           transform="translate(210.7451,280.042)"><path
             d="m 0,0 -72.439,-72.44 c 5.535,-9.373 5.535,-21.11 0,-30.483 l 38.813,-38.813 c 9.373,5.535 21.11,5.535 30.483,0 l 72.44,72.439"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3782" /></g><g
           id="g3784"
           transform="translate(112.4731,420.7402)"><path
             d="m 0,0 308.267,-308.267 c 74.93,85.832 71.526,216.266 -10.237,298.03 C 216.266,71.526 85.832,74.93 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3786" /></g><g
           id="g3788"
           transform="translate(38.0322,241)"><path
             d="m 0,0 c 3.472,-50.818 24.617,-100.654 63.465,-139.503 81.764,-81.764 212.197,-85.167 298.029,-10.237 L 53.228,158.526 C 20.896,121.491 3.163,76.15 0.002,30"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3790" /></g></g></g></g></svg>
</template>
